import {Component, ComponentRef, Injector, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import { ChangePasswordViewModel } from "../../../admin-panel/Users/users-dialog-base/users-dialog-base.component";
import { UserViewModel, AccessRights, UserCreateViewModel, ApplicationUserStatisticsView } from "../../../../services/users.service";
import {GeocoderViewModel, SettingsService, TimezoneViewModel} from "../../../../services/settings.service";
import {LanguageModel, LanguageService} from "../../../../services/language.service";
import {DialogBaseComponent} from "../../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";
import { DialogService } from "../../../../services/dialog.service";
import {CreateUserComponent} from "../../../admin-panel/Users/create-user.component";
import {EditUserComponent} from "../../../admin-panel/Users/edit-user.component";

@Component({
    selector: 'app-users-dialog',
    templateUrl: './users-dialog.component.html',
    styleUrls: ['./users-dialog.component.css'],
    standalone: false
})
export class UsersDialogComponent extends DialogBaseComponent<ApplicationUserStatisticsView> implements OnInit {

  @ViewChild("mgmtDialog", { read: ViewContainerRef, static: true }) container;
  protected componentRef: ComponentRef<any>;

  public term: string;

  public users: ApplicationUserStatisticsView[] = [];

  private selectedTab: string = 'allUsers';

  public geocoders: GeocoderViewModel[] = [];
  public languages: LanguageModel[] = [];

  public user: UserViewModel = new UserViewModel();
  public changePasswordModel: ChangePasswordViewModel = new ChangePasswordViewModel();
  public timezones: TimezoneViewModel[] = [];

  constructor(private settingsService: SettingsService,
            private dialogService: DialogService,
              private languageService: LanguageService,
              protected injector: Injector)
  {
    super(injector);

    this.settingsService.getGeocoders().subscribe(res => {
      this.geocoders = res;
    });

    this.languageService.getLanguages().subscribe(res => {
      this.languages = res;
    });

    this.usersService.getUserDetails(this.usersService.getCurrentUser().Id)
      .subscribe(result =>
      {
        this.user = result;

        this.settingsService.getTimezones().subscribe(res =>
        {
          this.timezones = res;
          if (this.user.TimeZone == "")
            this.user.TimeZone = this.timezones.find(tz => tz.Offset === 0).Name;
        });
      });

    this.refresh();
  }

  public canAccessUsers() {
    return this.usersService.IsPermitted(AccessRights.EDITUSERS) || this.users.length > 1;
  }

  public deleteUser(user: UserViewModel) {
    let message = this.translate.instant("Delete");
    if (!confirm(message + " " + user.Name + "?"))
      return;

    this.usersService.deleteUser(user.Id).subscribe(() => {
      this.refresh();
    });
  }


  ngOnInit() {
    super.ngOnInit();
  }

  public userSelected(id: number, name: string) {
    /*if (this.subuser && this.subuser.Id == id || id == this.usersService.getCurrentUser().Id) {
      this.usersService.subuserLogout().subscribe(() => {
          location.reload();
        });
    }
    else*/
    if (this.usersService.getUserName() != name)
      this.usersService.userSelected(id).subscribe(() => {
        location.reload();
      });
  }

  public refresh() {
    this.usersService.getUsers().subscribe(users => {
      this.users = users;
      if (!this.canAccessUsers())
        this.selectedTab = 'myProfile';
    });
  }

  public selectTab(tabName: string) {
    this.selectedTab = tabName;
  }

  public isTabSelected(tabName: string) {
    return this.selectedTab == tabName;
  }

  public openCreateModal() {
    this.componentRef = this.dialogService.open(this.container, CreateUserComponent);
    this.componentRef.instance.users = this.users;
    this.componentRef.instance.changePasswordModel = new ChangePasswordViewModel();
    this.componentRef.instance.open(new UserCreateViewModel());
  }

  public openEditModal(user: UserViewModel) {
    this.componentRef = this.dialogService.open(this.container, EditUserComponent);
    this.componentRef.instance.users = this.users;
    this.componentRef.instance.changePasswordModel = new ChangePasswordViewModel();
    this.componentRef.instance.open(new UserViewModel());
    this.usersService.getUserDetails(user.Id)
      .subscribe(result => {
        this.componentRef.instance.model = result;
        if (this.componentRef.instance.loadObjectGroupsFromModel) {
          this.componentRef.instance.loadObjectGroupsFromModel();
        }
      });
  }

  public onChangeUnits(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    if (value == "MILES")
      this.user.SetFlag("MILES");
    else
      this.user.ResetFlag("MILES");
  }

  public changePassword() {
    this.changePasswordModel.UserId = this.user.Id;
    this.usersService.changePassword(this.changePasswordModel)
      .subscribe(() => {
          this.toastr.success(this.translate.instant("Your password has been changed"));
        });
  }

  public submit() {
    if (this.isTabSelected('myProfile'))
      this.usersService.updateUser(this.user)
        .subscribe(() => {
            this.usersService.initializeUser();
            this.syncService.NotifyEntityChanged("User", this.user.Id);
          });
    super.submit();
  }
}
